import { Component, Input } from '@angular/core';
import { AuthorizationDiagnosisPac } from '@core/model';

@Component({
    selector: 'diagnosis-details',
    templateUrl: './diagnosis-details.component.html',
    styleUrls: ['./diagnosis-details.component.scss'],
    standalone: false
})
export class DiagnosisDetailsComponent {
  @Input() diagnosis!: AuthorizationDiagnosisPac[];
  @Input() isPASComplete: boolean;
}
